export function restrictBack() {
  window.history.pushState(null, null, window.location.href);
  window.addEventListener('popstate', function() {
    window.history.pushState(null, null, window.location.href);
  });
}
